import styled from "styled-components";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import Home from "./components/Home";

import Model from "./components/Model";
import Gallery from "./components/Gallery";
import { useLayoutEffect } from "react";
import ScrollTop from "./ScrollTop";

function App() {
  return (
    <Container>
      <Router>
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/work" element={<Gallery />} />
          <Route path="/talent" element={<Model />} />
        </Routes>
      </Router>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;

  max-width: 2400px;
  background-color: #161616;
  overflow-x: hidden;
`;

export default App;
